export default {"src":"/_next/static/media/pag-lee-favicon.d0c10f78.ico","height":48,"width":48};